<div>
  <mat-slide-toggle
    *ngIf="column && row"
    [(ngModel)]="data"
    (click)="stopPropagation($event)"
    (ngModelChange)="handleChange(data)"
  >
  </mat-slide-toggle>
</div>
